@if (fieldSet.includes(ServiceDataFields.ParaAndGravida)) {
  <div class="row">
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label for="numberOfPregnancies">{{
            'serviceData.form.numberOfPregnancies' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            type="number"
            formControlName="numberOfPregnancies"
            id="numberOfPregnancies"
            appInputValidationStatus
            [placeholder]="'serviceData.form.placeholders.gravida' | translate"
            data-cy="NumberOfPregnancies-input"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="numberOfPregnancies"
            translations="serviceData.form.validation.gravida"
            data-cy="NumberOfPregnancies-validation-error"
          ></app-validation-error>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label for="numberOfBirths">{{
            'serviceData.form.numberOfBirths' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            type="number"
            formControlName="numberOfBirths"
            id="numberOfBirths"
            appInputValidationStatus
            [placeholder]="'serviceData.form.placeholders.para' | translate"
            data-cy="NumberOfBirths-input"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="numberOfBirths"
            translations="serviceData.form.validation.para"
            data-cy="NumberOfBirths-validation-error"
          ></app-validation-error>
        </div>
      </div>
    </div>
  </div>
}
